<template>
    <be-wizard>
        <template slot="steps">
            <ul class="steps">
                <li v-for="(step, k) in steps" :key="k" :class="stepClass(k)" @click="toStep(k)">
                    {{ step.label }}
                    <span class="chevron"></span>
                </li>
            </ul>
        </template>

        <template slot="actions" v-if="disabled">
            <button type="button" class="btn btn-xs btn-prev btn-secondary" :disabled="active === 0" @click="toPrevious()">
                <i class="icon mdi mdi-chevron-left"></i> Zurück
            </button>
            <button type="button" class="btn btn-xs btn-prev btn-secondary" :disabled="active === steps.length - 1" @click="toNext()">
                <i class="icon mdi mdi-chevron-right"></i> Weiter
            </button>
        </template>

        <slot v-if="!currentView"/>
        <component ref="exam" :is="currentView" :input="formData" :disabled="disabled" :first-step="isFirstStep" :last-step="isLastStep" @submit="onSubmit" @previous="onPrevious"/>
    </be-wizard>
</template>

<script>
    export default {
        props: {
            steps: {
                type: Array,
                required: true,
            },
            input: Object,
            disabled: Boolean,
        },

        data: () => ({
            active: 0,
            formData: {},
        }),

        computed: {
            isLastStep: vm => (vm.active === (vm.steps.length - 2)),
            isFirstStep: vm => (vm.active === 0),
            currentView: vm => (vm.steps[vm.active] ? vm.steps[vm.active].component : null),
        },

        methods: {
            stepClass(key) {
                return {
                    active: key === this.active,
                    complete: key < this.active || (this.disabled && key !== this.active),
                };
            },

            getFormData() {
                return Object.assign({}, this.formData, this.$refs.exam.getFormData());
            },

            toPrevious() {
                if (this.active === 0) {
                    return;
                }

                this.active -= 1;
            },

            toNext() {
                if (this.active === this.steps.length - 1) {
                    return;
                }

                this.active += 1;
            },

            toStep(key) {
                if (!this.disabled && (key >= this.active || this.active === this.steps.length - 1)) {
                    return;
                }

                this.active = key;
            },

            onSubmit(formData, next) {
                Object.assign(this.formData, this.formData, formData);

                if (!next) {
                    return;
                }

                this.active = this.active + 1;
                this.$scrollTo('#app');
                this.$emit('started');

                if (this.active === this.steps.length - 1) {
                    this.$emit('complete', this.formData);
                } else {
                    this.$emit('progress', this.formData);
                }
            },

            onPrevious(formData) {
                Object.assign(this.formData, this.formData, formData);

                this.active = this.active - 1;
                this.$scrollTo('#app');
                this.$emit('started');
            },
        },

        watch: {
            input() {
                this.formData = this.input;
            },
        },

        mounted() {
            if (this.input) {
                this.formData = this.input;
            }
        },
    };
</script>
